"use client";

import { c as _c } from "react/compiler-runtime";
import { CATEGORY_TO_NAME, CategoryEnum, EventEnum } from "@sprawdzonabron/shared";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { type ReactElement } from "react";
import { GiAmmoBox, GiM3GreaseGun, GiPistolGun, GiPowder, GiRoundStar, GiSawedOffShotgun } from "react-icons/gi";
import { PiGridFourBold } from "react-icons/pi";
import { TestIdEnum } from "../../../tests/types";
import { useAnalyticsEvent } from "../../api/hooks/useAnalyticsEvent";
import type { AvailableFiltersOptions } from "../../api/types/availableFilters";
import { CATEGORY_SLUG_TO_CATEGORY, CATEGORY_TO_SLUG } from "../../constants/categories";
const CATEGORY_TO_ICON: Record<CategoryEnum, ReactElement> = {
  [CategoryEnum.All]: <PiGridFourBold />,
  [CategoryEnum.Ammunition]: <GiAmmoBox />,
  [CategoryEnum.SpecialOffers]: <GiRoundStar />,
  [CategoryEnum.ShortWeapon]: <GiPistolGun />,
  [CategoryEnum.LongWeapon]: <GiM3GreaseGun />,
  [CategoryEnum.Shotgun]: <GiSawedOffShotgun />,
  [CategoryEnum.BlackPowder]: <GiPowder />
};
interface CategoryBarProps {
  categories: AvailableFiltersOptions["categories"];
}
export const CategoryBar = t0 => {
  const $ = _c(9);
  const {
    categories
  } = t0;
  const postEvent = useAnalyticsEvent(EventEnum.CategoryClick);
  const pathname = usePathname();
  let t1;
  if ($[0] !== postEvent) {
    t1 = id => {
      postEvent(id);
    };
    $[0] = postEvent;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleCategoryClick = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      value: CategoryEnum.All,
      label: CATEGORY_TO_NAME[CategoryEnum.All]
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== categories) {
    t3 = [t2, ...categories];
    $[3] = categories;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const allCategories = t3;
  const activeCategory = Object.entries(CATEGORY_SLUG_TO_CATEGORY).find(t4 => {
    const [slug, category] = t4;
    if (pathname === "/" && category === CategoryEnum.All) {
      return true;
    }
    if (pathname !== "/" && !!slug && pathname?.includes(slug)) {
      return true;
    }
  })?.[1] || CategoryEnum.All;
  let t5;
  if ($[5] !== activeCategory || $[6] !== allCategories || $[7] !== handleCategoryClick) {
    t5 = <div data-testid={TestIdEnum.CategoryBar} className="flex items-center gap-2 md:gap-3 overflow-x-auto p-4 scrollbar-hide md:justify-center">{allCategories.map(t6 => {
        const {
          value,
          label
        } = t6;
        const isActive = value === activeCategory;
        return <Link key={value} href={`/${CATEGORY_TO_SLUG[value]}`} onClick={() => handleCategoryClick(value)} data-testid={`${TestIdEnum.CategoryButtonPrefix}-${value}`} className={`
              flex items-center gap-2 px-4 py-2 rounded-full text-xs md:text-sm whitespace-nowrap font-semibold transition-all duration-200 border
              ${isActive ? "bg-brand-600 border-brand-600 text-white shadow-lg shadow-brand-500/20" : "bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-400 hover:border-brand-400 hover:text-brand-500"}
            `}><span className="text-base">{CATEGORY_TO_ICON[value]}</span>{label}</Link>;
      })}</div>;
    $[5] = activeCategory;
    $[6] = allCategories;
    $[7] = handleCategoryClick;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};